module.exports = __webpack_public_path__ + "dingbeauty-landing/img/system_01@1.b827b707.png";